module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-LightItalic.4ccf23a.ttf";